import { render, staticRenderFns } from "./PainterSuperTalkDetails.vue?vue&type=template&id=c8ec2bde&scoped=true"
import script from "./PainterSuperTalkDetails.vue?vue&type=script&lang=js"
export * from "./PainterSuperTalkDetails.vue?vue&type=script&lang=js"
import style0 from "./PainterSuperTalkDetails.vue?vue&type=style&index=0&id=c8ec2bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ec2bde",
  null
  
)

export default component.exports